import { SvgIcon, SvgIconProps } from '@mui/material'

const SensorIconV2 = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 19 19" {...props}>
      <rect
        x=".989"
        y=".793"
        width="16.972"
        height="16.972"
        rx="8.486"
        fill="#29AAE1"
      />
      <rect
        x=".989"
        y=".793"
        width="16.972"
        height="16.972"
        rx="8.486"
        stroke="#282828"
        strokeWidth="1.5"
      />
      <path
        d="M9.16 11.874c-.44 0-.827-.07-1.162-.212a1.906 1.906 0 0 1-.79-.605 1.646 1.646 0 0 1-.312-.906h1.187c.014.16.065.298.15.416.088.114.207.202.356.267.15.06.323.09.52.09.183 0 .34-.026.472-.076a.68.68 0 0 0 .308-.219.526.526 0 0 0 .109-.328.5.5 0 0 0-.144-.364.998.998 0 0 0-.397-.226 4.766 4.766 0 0 0-.583-.15 4.802 4.802 0 0 1-.72-.213 2.096 2.096 0 0 1-.55-.308 1.253 1.253 0 0 1-.356-.44 1.386 1.386 0 0 1-.123-.611c0-.34.087-.632.26-.878.174-.246.415-.435.723-.567.309-.132.664-.198 1.065-.198.407 0 .762.07 1.064.212.303.14.541.34.713.598.174.257.267.56.28.907H10.03a.756.756 0 0 0-.13-.36.703.703 0 0 0-.298-.24.999.999 0 0 0-.427-.089c-.174 0-.32.024-.44.072a.577.577 0 0 0-.27.198.482.482 0 0 0-.089.287c0 .116.04.213.116.29a.867.867 0 0 0 .308.191c.128.048.27.09.428.13.157.038.318.08.485.129.31.089.585.202.826.34.242.135.432.31.57.522.14.212.212.478.212.796 0 .311-.084.588-.253.831-.167.243-.408.435-.72.575-.312.14-.688.21-1.13.21Z"
        fill="#fff"
      />
    </SvgIcon>
  )
}

export default SensorIconV2
